import { useEffect, useState } from "react";

/**
 * UN SEUL AFFICHAGE DE LA PAGE (01/11/2026).
 *
 * Les mises en page avaient deux blocs : un pour l'ordinateur, un pour le
 * telephone, l'un cache par le CSS. Mais la page etait montee dans LES DEUX :
 * tout ce qu'elle rafraichissait seule (presence, demandes, achats caisse,
 * signal de vie...) partait deux fois au serveur. Environ 360 000 lectures
 * par jour pour rien.
 *
 * Ce crochet dit lequel des deux blocs est visible, avec la meme limite que
 * le CSS (md = 768 px) : seule celle-la monte la page.
 */
const REQUETE = "(max-width: 767.98px)";

function lire(): boolean {
  try {
    return typeof window !== "undefined" && window.matchMedia(REQUETE).matches;
  } catch {
    return false;
  }
}

export function useEcranEtroit(): boolean {
  const [etroit, setEtroit] = useState<boolean>(lire);
  useEffect(() => {
    let m: MediaQueryList;
    try {
      m = window.matchMedia(REQUETE);
    } catch {
      return;
    }
    const suivre = () => setEtroit(m.matches);
    suivre();
    m.addEventListener("change", suivre);
    return () => m.removeEventListener("change", suivre);
  }, []);
  return etroit;
}
